import api from '../../../api/client';
// components/Dashboard.js
import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import SummaryCards from "../../../components/SummaryCard";
import MonthlyTrend from "../../../components/MonthlyTrend";
import RecentTransactions from "../../../components/RecentTransactions";
import SalesChart from "../../../components/SalesChart";
import ExpensesChart from "../../../components/ExpenseChart";
import MainCard from "../../../components/Card/MainCard";

const Dashboard = ({ dateRange, fetchData, recentPayments }) => {
  const [dashboardData, setDashboardData] = useState(null);
useEffect(() => {
    fetchData("dashboard/comprehensive", setDashboardData);
  }, [dateRange, fetchData]);
if (!dashboardData) {
    return <div className="text-center py-4">No dashboard data available</div>;
  }

  return (
    <div className="mt-4">
      <SummaryCards
        data={dashboardData.summary}
        metrics={dashboardData.metrics}
      />

      <Row className="mt-4">
        <Col lg={4} md={4} className="mb-4">
          {/* <Col lg={4}> */}
          <MainCard title="Recent Payments">
            {recentPayments.length === 0 ? (
              <p className="text-muted">No recent payments</p>
            ) : (
              recentPayments.map((payment) => (
                <div key={payment.id} className="border-bottom pb-2 mb-1">
                  <div className="d-flex justify-content-between">
                    <strong className="text-capitalize">
                      {payment.status}
                    </strong>
                    <span>Ksh {payment?.amount?.toLocaleString()}</span>
                  </div>
                  <small className="text-muted">
                    {new Date(payment?.paymentDate)?.toLocaleDateString()} •{" "}
                    {payment.period}
                  </small>
                </div>
              ))
            )}
          </MainCard>
          {/* </Col> */}
        </Col>
        <Col lg={4} md={4} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Sales by Category</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() =>
                  fetchData("dashboard/comprehensive", setDashboardData)
                }
              >
                <i className="fas fa-sync-alt me-1"></i> Refresh
              </Button>
            </Card.Header>
            <Card.Body>
              <SalesChart data={dashboardData?.salesByCategory} />
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} md={4} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Expenses by Category</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() =>
                  fetchData("dashboard/comprehensive", setDashboardData)
                }
              >
                <i className="fas fa-sync-alt me-1"></i> Refresh
              </Button>
            </Card.Header>
            <Card.Body>
              <ExpensesChart data={dashboardData.expensesByCategory} />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Monthly Income vs Expenses</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => fetchData("dashboard", setDashboardData)}
              >
                <i className="fas fa-sync-alt me-1"></i> Refresh
              </Button>
            </Card.Header>
            <Card.Body>
              <MonthlyTrend dateRange={dateRange} datas={dashboardData.trend} />
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">Recent Transactions</h5>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() =>
                  fetchData("dashboard/comprehensive", setDashboardData)
                }
              >
                <i className="fas fa-sync-alt me-1"></i> Refresh
              </Button>
            </Card.Header>
            <Card.Body>
              <RecentTransactions
                transactions={dashboardData.recentTransactions}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
